export const SITESETUP_GET_ENROLLMENT_DETAILS =
  'SITESETUP_GET_ENROLLMENT_DETAILS';
export const SITESETUP_GET_ENROLLMENT_DETAILS_ERROR =
  'SITESETUP_GET_ENROLLMENT_DETAILS_ERROR';
export const SITESETUP_ENROLLMENT_FETCHING = 'SITESETUP_ENROLLMENT_FETCHING';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/enrollment/types.js